import { useState, useCallback } from 'react';
import useMenusApi from './useMenusApi';
import { Menu } from '../types';

const useMenusList = () => {
  const { getMenus } = useMenusApi();
  const [menus, setMenus] = useState<Menu[]>([]);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const loadMenus = useCallback(async (search: string, status: string, page: number, pageSize: number) => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await getMenus(search, status, page, pageSize);
      setMenus(response.data);
      setTotalCount(response.totalCount);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load menus');
      setMenus([]);
      setTotalCount(0);
    } finally {
      setIsLoading(false);
    }
  }, [getMenus]);

  return { menus, totalCount, isLoading, error, loadMenus };
};

export default useMenusList;
